import { useEffect } from 'react'
import { useFetcher } from 'react-router'

export interface UserRolesData {
	roles: string[]
	permissions: string[]
	userType: string
	loading: boolean
	error?: string
}

/**
 * Hook to get current user's roles and permissions
 */
export function useUserRoles(): UserRolesData {
	const fetcher = useFetcher<{
		roles: string[]
		permissions: string[]
		userType: string
		error?: string
	}>()

	useEffect(() => {
		// Only fetch if we haven't already fetched or if we're not currently fetching
		if (fetcher.state === 'idle' && !fetcher.data) {
			fetcher.load('/resources/user-roles')
		}
	}, [fetcher])

	return {
		roles: fetcher.data?.roles || [],
		permissions: fetcher.data?.permissions || [],
		userType: fetcher.data?.userType ?? 'tenant',
		loading: fetcher.state !== 'idle' || !fetcher.data,
		error: fetcher.data?.error,
	}
}
